import { InertiaApp } from '@inertiajs/inertia-vue'
import { plugin as inertiaPlugin } from '@inertiajs/inertia-vue'
import Vue from 'vue'
import VueMeta from 'vue-meta'
import PortalVue from 'portal-vue'
import filters from '@/admin/filters'
import moment from 'moment-mini'
import axios from 'axios'

import 'froala-editor/css/froala_editor.pkgd.min.css' // all styles (also for buttons)
import 'froala-editor/js/plugins.pkgd.min' // all plugins (you can add plugins by one too)
import VueFroala from 'vue-froala-wysiwyg' // editor

window.axios = axios
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

const tokenMetaTag = document.head.querySelector('meta[name="csrf-token"]')
if (tokenMetaTag) {
  window.csrfToken = tokenMetaTag.content
}

Vue.prototype.$eventHub = new Vue() // Global event bus
Vue.prototype.moment = moment
Vue.config.productionTip = false
Vue.mixin({ methods: { route: window.route } })

Vue.use(inertiaPlugin)
Vue.use(PortalVue)
Vue.use(VueMeta)
Vue.use(VueFroala)

const app = document.getElementById('app')

new Vue({
    metaInfo: {
        title: 'Loading…',
        titleTemplate: '%s | Admin'
    },
    render: h =>
        h(InertiaApp, {
            props: {
                initialPage: JSON.parse(app.dataset.page),
                resolveComponent: name => require(`./Pages/${name}`).default,
            }
        })
}).$mount(app)
